import { render, staticRenderFns } from "./EnrollStudentAttachmentSelect.vue?vue&type=template&id=6b9b3103"
import script from "./EnrollStudentAttachmentSelect.vue?vue&type=script&lang=js"
export * from "./EnrollStudentAttachmentSelect.vue?vue&type=script&lang=js"
import style0 from "./EnrollStudentAttachmentSelect.vue?vue&type=style&index=0&id=6b9b3103&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports